export const getStageStepKey = stageStep => `stageStep${stageStep}`;
